angular
  .module('app')
  .directive('pagination', function () {
    return {
      restrict: 'A',
      template: `
        <li class="page-item" ng-repeat="page in pages" ng-class="{ active: page.active, disabled: page.page === null }">
          <a href class="page-link" ng-click="onPageSelect(page)" ng-bind-html="::page.label"></a>
        </li>`,
      scope: {
        page: '=',
        numOfPages: '=',
        onPageSelect: '&',
      },
      link: (scope) => {
        function getPages(page, numOfPages) {
          if (!page || !numOfPages) {
            return [];
          }

          let i;

          const pages = [];

          pages.push({ label: '<span class="mdi mdi-arrow-left"></span>', page: (page > 1 ? page - 1 : null) });

          if (numOfPages <= 9) {
            for (i = 1; i <= numOfPages; i += 1) {
              pages.push({ label: i, page: i, active: i === page });
            }
          } else if (page <= 5) {
            // 1 2 3 4 5 6 7 ... 15

            for (i = 1; i <= 7; i += 1) {
              pages.push({ label: i, page: i, active: i === page });
            }

            pages.push({ label: '...' }, { label: numOfPages, page: numOfPages });
          } else if (page < numOfPages - 4) {
            // 1 ... 4 5 6 7 8 ... 15

            pages.push({ label: 1, page: 1 }, { label: '...' });

            for (i = page - 2; i <= page + 2; i += 1) {
              pages.push({ label: i, page: i, active: i === page });
            }

            pages.push({ label: '...' }, { label: numOfPages, page: numOfPages });
          } else {
            // 1 ... 9 10 11 12 13 14 15

            pages.push({ label: 1, page: 1 }, { label: '...' });

            for (i = numOfPages - 6; i <= numOfPages; i += 1) {
              pages.push({ label: i, page: i, active: i === page });
            }
          }

          pages.push({ label: '<span class="mdi mdi-arrow-right"></span>', page: (page < numOfPages ? page + 1 : null) });

          return pages;
        }

        scope.$watch('page', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            scope.pages = getPages(newValue, scope.numOfPages);

            console.log('page:', newValue);
          }
        });

        scope.$watch('numOfPages', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            scope.pages = getPages(scope.page, newValue);

            console.log('numOfPages:', newValue);
          }
        });

        scope.pages = getPages(scope.page, scope.numOfPages);
      },
    };
  });
